import React from 'react';
import Icon from '../../../components/AppIcon';

const QuoteItemsTable = ({ items, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-surface border border-border rounded-lg p-6 mb-6">
        <div className="animate-pulse">
          <div className="h-6 bg-muted rounded w-1/4 mb-4"></div>
          <div className="space-y-3">
            {[1, 2, 3, 4, 5]?.map((i) => (
              <div key={i} className="flex justify-between">
                <div className="h-4 bg-muted rounded w-1/2"></div>
                <div className="h-4 bg-muted rounded w-1/6"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    })?.format(price);
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-6 mb-6 shadow-soft">
      <h2 className="text-lg font-semibold text-text-primary mb-4 flex items-center space-x-2">
        <Icon name="FileText" size={20} />
        <span>Détail du Devis</span>
      </h2>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-2 text-sm font-semibold text-text-primary">Description</th>
              <th className="text-center py-3 px-2 text-sm font-semibold text-text-primary w-20">Qté</th>
              <th className="text-right py-3 px-2 text-sm font-semibold text-text-primary w-24">Prix Unit.</th>
              <th className="text-right py-3 px-2 text-sm font-semibold text-text-primary w-24">Total</th>
            </tr>
          </thead>
          <tbody>
            {items?.map((item, index) => (
              <tr key={index} className="border-b border-border hover:bg-muted/50 transition-smooth">
                <td className="py-3 px-2">
                  <div>
                    <p className="text-sm font-medium text-text-primary">{item?.description}</p>
                    {item?.details && (
                      <p className="text-xs text-text-secondary mt-1">{item?.details}</p>
                    )}
                  </div>
                </td>
                <td className="py-3 px-2 text-center text-sm text-text-primary">
                  {item?.quantity}
                  {item?.unit && <span className="text-text-secondary ml-1">{item?.unit}</span>}
                </td>
                <td className="py-3 px-2 text-right text-sm text-text-primary">
                  {formatPrice(item?.unitPrice)}
                </td>
                <td className="py-3 px-2 text-right text-sm font-medium text-text-primary">
                  {formatPrice(item?.total)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuoteItemsTable;